import { render, staticRenderFns } from "./TopupPackage.vue?vue&type=template&id=6e9215f7&"
import script from "./TopupPackage.vue?vue&type=script&lang=js&"
export * from "./TopupPackage.vue?vue&type=script&lang=js&"
import style0 from "./TopupPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VStepper,VStepperContent,VStepperHeader,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9215f7')) {
      api.createRecord('6e9215f7', component.options)
    } else {
      api.reload('6e9215f7', component.options)
    }
    module.hot.accept("./TopupPackage.vue?vue&type=template&id=6e9215f7&", function () {
      api.rerender('6e9215f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpPackage/TopupPackage.vue"
export default component.exports